import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getWorkbookDisplayMode,
  isTreeBuilderDisplayed,
  isViewModeDisplayed,
  isWorksheetDisplayed as worksheetDisplayed,
} from '@/main/routing.utilities';
import type { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

export const useRoutingData = () => {
  const [isWorksheetDisplayed, setIsWorksheetDisplayed] = useState(false);
  const [workbookDisplayMode, setWorkbookDisplayMode] = useState<WORKBOOK_DISPLAY>();
  const [isViewMode, setIsViewMode] = useState(false);
  const [isTreeBuilder, setIsTreeBuilder] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    setIsWorksheetDisplayed(worksheetDisplayed(path));
    setWorkbookDisplayMode(getWorkbookDisplayMode(path));
    setIsViewMode(isViewModeDisplayed(path));
    setIsTreeBuilder(isTreeBuilderDisplayed(path));
  }, [location]);

  return { workbookDisplayMode, isWorksheetDisplayed, isViewMode, isTreeBuilder };
};
